import { Box } from "@mui/joy";
import logo from "./corkatlas_square_logo.png"

function AuthLogo(props) {
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <img src={logo} alt="logo" style={{
        width: props.size,
        height: props.size,
      }} />
    </Box>
  )
}

export default AuthLogo;
